"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Launch = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SvgIcon = _interopRequireWildcard(require("./SvgIcon"));
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var Launch = exports.Launch = function Launch(props) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], _extends({
    fill: "none"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "currentColor",
    d: "M15 3.5V2h7.5v7.5H21V4.5605L14.5605 11 13.5 9.9395 19.9395 3.5H15z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "currentColor",
    d: "M3 21.5c.375 0 1.1023-.0005 1.5 0h15c.3977-.0005 1.125 0 1.5 0 0-.375-.0005-1.1023 0-1.5v-7.5h-1.5V20h-15V5H12V3.5H4.5c-.3977.0005-1.125 0-1.5 0 0 .375.0005 1.1023 0 1.5v15c.0005.3977 0 1.125 0 1.5z"
  }));
};
Launch.propTypes = process.env.NODE_ENV !== "production" ? {
  kind: _propTypes["default"].oneOf(Object.keys(_SvgIcon.KIND)),
  size: _propTypes["default"].oneOf(Object.keys(_SvgIcon.SIZE)),
  title: _propTypes["default"].string,
  color: _propTypes["default"].oneOf(Object.keys(_SvgIcon.COLOR)),
  htmlColor: _propTypes["default"].string,
  fontSize: _propTypes["default"].oneOf(['medium', 'inherit', 'small', 'large']),
  viewBox: _propTypes["default"].string
} : {};
Launch.defaultProps = {
  viewBox: '0 0 24 24'
};
var _default = exports["default"] = Launch;